<script lang="ts">
    import type {MessageAudio} from "./Types";
    import Audio from "./Audio.svelte";
    import FormattedText from "./FormattedText.svelte";
    import Audio from "./Audio.svelte";

    export let entity: MessageAudio
    export let attachments: ChatMessageAttachmentData[]
</script>
<div class="alert alert-warning m-0">
    Аудіо <br/>
    <FormattedText entity="{entity.caption}"/>
    <Audio entity="{entity.audio}" {attachments}/>
</div>
